import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "l-reservation-desc py-40px py-lg-60px" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "row justify-content-center" };
const _hoisted_4 = { class: "col col-lg-6 text-center" };
const _hoisted_5 = { class: "h3 mb-12px text-primary" };
const _hoisted_6 = { class: "mb-0" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_9 = { class: "text-danger" };
const _hoisted_10 = { class: "l-reservation-infos py-40px py-lg-80px" };
const _hoisted_11 = { class: "container" };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "col" };
const _hoisted_14 = { class: "d-lg-flex gap-40px position-relative" };
const _hoisted_15 = { class: "mb-40px mb-lg-0 ps-0 w-100" };
const _hoisted_16 = { class: "l-reservation-infos-card card border-0 bg-white" };
const _hoisted_17 = { class: "card-body p-0" };
const _hoisted_18 = { class: "card-title mb-0 mb-lg-12px p-20px px-lg-40px d-flex gap-20px align-items-center" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("span", { class: "h5 mb-0 text-primary d-flex justify-content-center align-items-center" }, " 01 ", -1);
const _hoisted_20 = { class: "h5 mb-0 text-primary" };
const _hoisted_21 = { class: "c-card-content p-20px p-lg-40px pt-lg-20px d-flex flex-column flex-lg-row gap-4" };
const _hoisted_22 = { class: "c-card-content__item c-card-content__item--select" };
const _hoisted_23 = { class: "form-label h6 mb-3" };
const _hoisted_24 = ["value"];
const _hoisted_25 = { class: "c-card-content__item c-card-content__item--select" };
const _hoisted_26 = { class: "form-label h6 mb-3" };
const _hoisted_27 = ["value"];
const _hoisted_28 = { class: "l-reservation-infos-card card border-0 bg-white" };
const _hoisted_29 = { class: "card-body p-0" };
const _hoisted_30 = { class: "card-title mb-0 mb-lg-12px p-20px px-lg-40px d-flex gap-20px align-items-center" };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("span", { class: "h5 mb-0 text-primary d-flex justify-content-center align-items-center" }, " 02 ", -1);
const _hoisted_32 = { class: "h5 mb-0 text-primary" };
const _hoisted_33 = { class: "c-card-content px-20px px-lg-40px pt-20px pb-12px" };
const _hoisted_34 = { class: "c-card-content__item c-card-content__item--calendar" };
const _hoisted_35 = { class: "form-label h6 mb-3" };
const _hoisted_36 = ["value"];
const _hoisted_37 = { class: "c-card-content px-20px px-lg-40px pt-20px pb-12px" };
const _hoisted_38 = { class: "c-card-content__item c-card-content__item--time" };
const _hoisted_39 = { class: "form-label h6 mb-3" };
const _hoisted_40 = ["value"];
const _hoisted_41 = { class: "c-card-content px-20px px-lg-40px pt-20px pb-12px d-flex gap-4" };
const _hoisted_42 = { class: "c-card-content__item c-card-content__item--select" };
const _hoisted_43 = { class: "form-label h6 mb-3" };
const _hoisted_44 = ["value"];
const _hoisted_45 = { class: "c-card-content__item c-card-content__item--select" };
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("label", { class: "form-label h6 mb-3 opacity-0" }, " 用餐人數 ", -1);
const _hoisted_47 = ["value"];
const _hoisted_48 = {
    key: 0,
    class: "c-card-content px-20px px-lg-40px pb-12px text-danger small"
};
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_50 = {
    key: 1,
    class: "c-card-content px-20px px-lg-40px pb-12px text-danger small"
};
const _hoisted_51 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_52 = {
    key: 2,
    class: "c-card-content px-20px px-lg-40px pt-20px pb-12px"
};
const _hoisted_53 = {
    key: 3,
    class: "c-card-content px-20px px-lg-40px pt-20px pb-12px"
};
const _hoisted_54 = {
    key: 4,
    class: "c-card-content px-20px px-lg-40px pt-20px pb-12px"
};
const _hoisted_55 = ["src"];
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("div", { class: "c-menu-thumbnail__overlay" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "c-menu-thumbnail__icon" }, "🔍")
], -1);
const _hoisted_57 = ["src"];
const _hoisted_58 = {
    key: 5,
    class: "c-card-content p-20px p-lg-40px pt-lg-20px"
};
const _hoisted_59 = { class: "c-card-content__item c-card-content__item--child-seat" };
const _hoisted_60 = { class: "form-label h6 mb-3" };
const _hoisted_61 = { class: "row align-items-center" };
const _hoisted_62 = { class: "col-md-6" };
const _hoisted_63 = { class: "form-check d-flex gap-20px align-items-center" };
const _hoisted_64 = {
    class: "form-check-label",
    for: "need-child-set-option-1"
};
const _hoisted_65 = { class: "col-md-6" };
const _hoisted_66 = { class: "form-check" };
const _hoisted_67 = {
    class: "form-check-label",
    for: "need-child-set-option-2"
};
const _hoisted_68 = {
    key: 0,
    class: "l-reservation-infos-card card border-0 bg-white"
};
const _hoisted_69 = { class: "card-body p-0" };
const _hoisted_70 = { class: "card-title mb-0 mb-lg-12px p-20px px-lg-40px d-flex gap-20px align-items-center" };
const _hoisted_71 = /*#__PURE__*/ _createElementVNode("span", { class: "h5 mb-0 text-primary d-flex justify-content-center align-items-center" }, " 03 ", -1);
const _hoisted_72 = { class: "h5 mb-0 text-primary" };
const _hoisted_73 = { class: "c-card-content px-20px px-lg-40px pt-20px pb-12px d-flex flex-column flex-lg-row gap-4" };
const _hoisted_74 = { class: "c-card-content__item" };
const _hoisted_75 = {
    class: "form-label h6 mb-3",
    for: "input-name"
};
const _hoisted_76 = /*#__PURE__*/ _createElementVNode("span", { class: "small text-danger" }, "*", -1);
const _hoisted_77 = { class: "c-card-content__item c-card-content__item--select" };
const _hoisted_78 = { class: "form-label h6 mb-3" };
const _hoisted_79 = { class: "c-card-content__item px-20px px-lg-40px pt-20px pb-12px d-flex flex-column flex-lg-row gap-4" };
const _hoisted_80 = {
    class: "form-label h6 mb-3",
    for: "input-phone"
};
const _hoisted_81 = /*#__PURE__*/ _createElementVNode("span", { class: "small text-danger" }, "*", -1);
const _hoisted_82 = { class: "small" };
const _hoisted_83 = { class: "input-group input-group-lg d-flex align-items-stretch" };
const _hoisted_84 = { class: "c-card-content px-20px px-lg-40px pt-20px pb-12px" };
const _hoisted_85 = { class: "c-card-content__item" };
const _hoisted_86 = {
    class: "form-label h6 mb-3",
    for: "input-email"
};
const _hoisted_87 = {
    key: 0,
    class: "small text-danger"
};
const _hoisted_88 = {
    key: 1,
    class: "small text-secondary"
};
const _hoisted_89 = { class: "c-card-content px-20px px-lg-40px pt-20px pb-12px" };
const _hoisted_90 = { class: "c-card-content__item" };
const _hoisted_91 = { class: "form-label h6 mb-3" };
const _hoisted_92 = { class: "small" };
const _hoisted_93 = { class: "d-flex flex-wrap gap-3" };
const _hoisted_94 = ["id", "value"];
const _hoisted_95 = ["for"];
const _hoisted_96 = { class: "c-card-content px-20px px-lg-40px pt-20px pb-12px" };
const _hoisted_97 = { class: "c-card-content__item" };
const _hoisted_98 = { class: "form-label h6 mb-3" };
const _hoisted_99 = { class: "small" };
const _hoisted_100 = { class: "d-flex gap-3" };
const _hoisted_101 = ["placeholder"];
const _hoisted_102 = { class: "c-card-content p-20px p-lg-40px pt-lg-20px" };
const _hoisted_103 = { class: "c-card-content__item" };
const _hoisted_104 = { class: "form-check d-flex gap-2 justify-content-center" };
const _hoisted_105 = { class: "c-order-details position-sticky" };
const _hoisted_106 = { class: "c-order-details-card card border-0" };
const _hoisted_107 = { class: "card-header border-0 p-20px" };
const _hoisted_108 = { class: "h4 mb-0 text-center text-primary" };
const _hoisted_109 = { class: "card-body p-20px" };
const _hoisted_110 = { class: "h6 mb-1 text-center text-primary" };
const _hoisted_111 = { class: "mb-20px text-center" };
const _hoisted_112 = { class: "mb-0 ps-0 text-primary" };
const _hoisted_113 = { class: "mb-2 d-flex flex-wrap justify-content-between align-items-center" };
const _hoisted_114 = { class: "card-body__label" };
const _hoisted_115 = { class: "card-body__value" };
const _hoisted_116 = { class: "small mt-2 mb-0 ps-0 w-100" };
const _hoisted_117 = { class: "c-meals-details d-flex justify-content-between" };
const _hoisted_118 = { class: "d-flex gap-12px" };
const _hoisted_119 = {
    key: 0,
    class: "text-nowrap"
};
const _hoisted_120 = {
    key: 0,
    class: "c-meals-details d-flex justify-content-between"
};
const _hoisted_121 = { class: "text-nowrap" };
const _hoisted_122 = { class: "mb-2 d-flex flex-wrap justify-content-between align-items-center" };
const _hoisted_123 = { class: "card-body__label" };
const _hoisted_124 = { class: "card-body__value" };
const _hoisted_125 = {
    key: 0,
    class: "d-flex flex-wrap justify-content-between align-items-center"
};
const _hoisted_126 = { class: "card-body__label" };
const _hoisted_127 = { class: "card-body__value" };
const _hoisted_128 = /*#__PURE__*/ _createElementVNode("span", null, "-", -1);
const _hoisted_129 = { class: "d-block text-muted" };
const _hoisted_130 = {
    key: 1,
    class: "mt-2 d-flex flex-wrap justify-content-between align-items-center"
};
const _hoisted_131 = { class: "card-body__label" };
const _hoisted_132 = { class: "card-body__value" };
const _hoisted_133 = { class: "card-footer border-0 p-20px bg-white" };
const _hoisted_134 = {
    key: 0,
    class: "mb-40px d-flex justify-content-between"
};
const _hoisted_135 = { class: "text-primary" };
const _hoisted_136 = { class: "h5 mb-0" };
const _hoisted_137 = { class: "mb-20px d-flex flex-wrap gap-20px justify-content-center" };
const _hoisted_138 = {
    key: 1,
    class: "small text-danger"
};
const _hoisted_139 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" };
const _hoisted_140 = { class: "modal-content border-0" };
const _hoisted_141 = { class: "modal-header py-20px px-4 justify-content-center bg-primary position-relative" };
const _hoisted_142 = { class: "modal-body p-40px" };
const _hoisted_143 = {
    key: 0,
    class: "c-reservation-content mb-0 ps-0 overflow-y-auto"
};
const _hoisted_144 = {
    key: 0,
    class: "mb-40px"
};
const _hoisted_145 = { class: "alert alert-warning mb-0 text-danger fw-bold" };
const _hoisted_146 = { class: "mb-40px" };
const _hoisted_147 = { class: "l-tab-title h6 mb-12px text-primary" };
const _hoisted_148 = ["innerHTML"];
const _hoisted_149 = { class: "mb-40px pt-40px" };
const _hoisted_150 = { class: "l-tab-title h6 mb-12px text-primary" };
const _hoisted_151 = ["innerHTML"];
const _hoisted_152 = { class: "mb-40px pt-40px" };
const _hoisted_153 = { class: "l-tab-title h6 mb-12px text-primary" };
const _hoisted_154 = ["innerHTML"];
const _hoisted_155 = { class: "pt-40px" };
const _hoisted_156 = { class: "l-tab-title h6 mb-12px text-primary" };
const _hoisted_157 = ["innerHTML"];
const _hoisted_158 = {
    key: 1,
    class: "text-center c-editor-content h5 mb-0"
};
const _hoisted_159 = { class: "modal-footer border-0 p-40px flex-column gap-40px" };
const _hoisted_160 = { class: "form-check d-flex gap-2 justify-content-center" };
const _hoisted_161 = {
    class: "form-check-label",
    for: "submit-check"
};
const _hoisted_162 = {
    key: 0,
    id: "g-recaptcha-container",
    style: { "display": "none" }
};
const _hoisted_163 = ["disabled"];
const _hoisted_164 = { key: 0 };
const _hoisted_165 = { key: 1 };
const _hoisted_166 = /*#__PURE__*/ _createElementVNode("div", {
    class: "spinner-border text-primary",
    role: "status"
}, [
    /*#__PURE__*/ _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1);
const _hoisted_167 = [
    _hoisted_166
];
const _hoisted_168 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" };
const _hoisted_169 = { class: "modal-content border-0" };
const _hoisted_170 = { class: "modal-header py-20px px-4 justify-content-center bg-primary position-relative" };
const _hoisted_171 = {
    class: "modal-title fs-5 text-white",
    id: "duplicateModalLabel"
};
const _hoisted_172 = /*#__PURE__*/ _createElementVNode("button", {
    type: "button",
    class: "btn-close disabled d-none",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
}, null, -1);
const _hoisted_173 = { class: "modal-body p-40px" };
const _hoisted_174 = { class: "text-center mb-40px" };
const _hoisted_175 = { class: "h5 text-primary mb-0" };
const _hoisted_176 = { class: "mb-20px" };
const _hoisted_177 = { class: "h6 mb-12px" };
const _hoisted_178 = { class: "d-flex justify-content-between align-items-center mb-12px" };
const _hoisted_179 = { class: "d-flex justify-content-between align-items-center mb-12px" };
const _hoisted_180 = /*#__PURE__*/ _createElementVNode("div", null, " Line ID ", -1);
const _hoisted_181 = { class: "d-flex justify-content-between align-items-center mb-12px" };
const _hoisted_182 = /*#__PURE__*/ _createElementVNode("div", null, " Email ", -1);
const _hoisted_183 = { class: "modal-footer border-0 p-40px flex-column gap-40px" };
const _hoisted_184 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_185 = { class: "modal-content border border-dark" };
const _hoisted_186 = { class: "modal-header py-20px px-4 justify-content-center bg-primary position-relative" };
const _hoisted_187 = {
    class: "modal-title fs-5 text-white",
    id: "otpModalLabel"
};
const _hoisted_188 = { class: "modal-body p-40px" };
const _hoisted_189 = {
    key: 0,
    class: "text-center mb-20px"
};
const _hoisted_190 = {
    key: 1,
    class: "alert alert-warning small py-2 px-3 mb-20px"
};
const _hoisted_191 = { class: "mb-20px" };
const _hoisted_192 = { class: "form-label h6 mb-3" };
const _hoisted_193 = ["placeholder"];
const _hoisted_194 = { class: "small text-muted mb-12px" };
const _hoisted_195 = {
    key: 2,
    class: "text-danger small"
};
const _hoisted_196 = {
    key: 3,
    class: "text-danger small"
};
const _hoisted_197 = { class: "small text-muted mt-3 pt-3 border-top" };
const _hoisted_198 = {
    key: 0,
    class: "mb-2 text-primary"
};
const _hoisted_199 = { class: "mb-2 text-danger" };
const _hoisted_200 = {
    key: 1,
    class: "ps-2"
};
const _hoisted_201 = { key: 0 };
const _hoisted_202 = { key: 1 };
const _hoisted_203 = { key: 2 };
const _hoisted_204 = { class: "text-danger fw-bold mt-3" };
const _hoisted_205 = { class: "modal-footer border-0 p-40px flex-column gap-20px" };
const _hoisted_206 = ["disabled"];
const _hoisted_207 = { key: 0 };
const _hoisted_208 = { key: 1 };
const _hoisted_209 = ["disabled"];
const _hoisted_210 = { key: 0 };
const _hoisted_211 = { key: 1 };
const _hoisted_212 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_213 = { class: "modal-content border-0" };
const _hoisted_214 = { class: "modal-header py-20px px-4 justify-content-center bg-primary position-relative" };
const _hoisted_215 = {
    class: "modal-title fs-5 text-white",
    id: "captchaModalLabel"
};
const _hoisted_216 = { class: "modal-body p-40px" };
const _hoisted_217 = { class: "text-center mb-20px" };
const _hoisted_218 = { class: "d-flex flex-column align-items-center gap-3 mb-20px" };
const _hoisted_219 = ["src"];
const _hoisted_220 = ["disabled"];
const _hoisted_221 = { class: "mb-20px" };
const _hoisted_222 = { class: "form-label h6 mb-3" };
const _hoisted_223 = ["placeholder"];
const _hoisted_224 = { class: "small text-muted mb-12px" };
const _hoisted_225 = {
    key: 0,
    class: "text-danger small"
};
const _hoisted_226 = {
    key: 1,
    class: "text-danger small"
};
const _hoisted_227 = { class: "modal-footer border-0 p-40px flex-column gap-20px" };
const _hoisted_228 = ["disabled"];
const _hoisted_229 = { key: 0 };
const _hoisted_230 = { key: 1 };
import { DepositType } from '@js/types/enum/deposit-type';
import { MealType } from '@js/types/enum/meal-type';
import { ORDER_PURPOSE_OPTIONS } from '@js/types/enum/order-purpose';
import { localize, setLocale } from '@vee-validate/i18n';
import { all as rules } from '@vee-validate/rules';
import InputField from '@vue/components/form/InputField.vue';
import MealsField from '@vue/components/form/MealsField.vue';
import PhoneField from '@vue/components/form/PhoneField.vue';
import PolicyCheckField from '@vue/components/form/PolicyCheckField.vue';
import SelectField from '@vue/components/form/SelectField.vue';
import { MainStore } from '@vue/services/store';
import dayjs from 'dayjs';
import { configure, defineRule, useForm } from 'vee-validate';
import { computed, inject, onMounted, reactive, ref, watch } from 'vue';
import { $lang, dateFormat, dateFormatTaipei, priceFormat } from '../services/utilities';
import { PaymentType } from '@js/types/enum/payment-type';
import { nextTick } from 'vue';
import 'tom-select/dist/css/tom-select.bootstrap5.min.css';
const MENU_IMAGE_VERSION = 1;
const RECAPTCHA_TIMEOUT_MS = 120000;
export default /*#__PURE__*/ _defineComponent({
    __name: 'ReservationForm',
    props: {
        brands: {},
        stores: {}
    },
    emits: ['toSearchList'],
    setup(__props, { emit: __emit }) {
        const emits = __emit;
        const locale = inject('locale');
        const rcKey = u.data('rcKey') ?? null;
        configureForm();
        const props = __props;
        const formData = reactive({
            storeId: 0,
            date: '',
            timeSlotId: 0,
            adult: MainStore.adults,
            child: MainStore.children,
            childSeat: 0,
            purpose: [],
            customerNote: '',
            meals: [],
            additionalMeals: [],
            name: '',
            countryCode: '+886',
            phone: '',
            gender: 0,
            email: '',
            language: locale,
            gRecaptchaResponse: '',
            otpVerifiedToken: '',
            captchaVerifiedToken: '',
            skipDeposit: false,
            paymentType: PaymentType.WEB_ATM,
            noOnlinePayment: false,
            // 店卡選的座位類型（板前席／雅座席）；空字串＝該店不用選，後端照舊
            seatType: MainStore.seatType ?? '',
        });
        let recaptchaWidgetId = null;
        onMounted(async () => {
            if (rcKey) {
                loadRecaptcha();
            }
            await loadTimeSlot();
            await loadMeals();
        });
        const brand = computed(() => {
            return props.brands.find(v => v.id === MainStore.brandId);
        });
        const brandTitle = computed(() => {
            if (!brand.value) {
                return '';
            }
            return locale === 'zh-TW' ? brand.value.tw.title : brand.value.en.title;
        });
        const store = computed(() => {
            return props.stores.find(v => v.id === MainStore.storeId);
        });
        const storeTitle = computed(() => {
            const store = props.stores.find(v => v.id === MainStore.storeId);
            if (!store) {
                return '';
            }
            const title = locale === 'zh-TW' ? store.tw.title : store.en.title;
            // 有選座位類型（同一家店有板前與雅座）時，店名後面標出客人選的那一類
            return formData.seatType
                ? `${title}（${$lang('app.reservation.seat.type.' + formData.seatType)}）`
                : title;
        });
        const adults = computed(() => {
            return formData.adult + $lang('app.reservation.option.adult');
        });
        const children = computed(() => {
            return formData.child + $lang('app.reservation.option.child');
        });
        const meals = ref([]);
        const selectedMeals = computed(() => {
            const main = formData.meals.map((v) => {
                const meal = meals.value?.find(meal => meal.id === v.id);
                const price = meal?.price * v.quantity;
                return {
                    title: locale === 'zh-TW' ? meal?.tw.title : meal?.en.title,
                    quantity: v.quantity,
                    price: priceFormat(price)
                };
            });
            const additional = formData.additionalMeals.map((v) => {
                const meal = meals.value?.find(meal => meal.id === v.id);
                const price = meal?.price * v.quantity;
                return {
                    title: locale === 'zh-TW' ? meal?.tw.title : meal?.en.title,
                    quantity: v.quantity,
                    price: priceFormat(price)
                };
            });
            return [...main, ...additional];
        });
        async function loadMeals() {
            // 確保 timeSlot 先拿到（它有 id）
            if (!timeSlot.value?.id) {
                await loadTimeSlot();
            }
            const res = await u.$http.get('front/reserve/loadMeals', {
                params: {
                    storeId: MainStore.storeId,
                    date: dayjs(MainStore.date).format('YYYY-MM-DD'),
                    storeTimeSlotId: Number(timeSlot.value?.id || 0), // ✅ 新增
                }
            });
            meals.value = res.data.data.items ?? [];
        }
        const needChildSeat = ref(false);
        const childSeatOptions = computed(() => {
            const options = [];
            for (let i = 1; i <= formData.child; i++) {
                options.push({
                    text: i,
                    value: i
                });
            }
            return options;
        });
        watch(() => needChildSeat.value, (v) => {
            if (!v) {
                formData.childSeat = 0;
            }
        });
        function setChildSeatData(v) {
            if (v === '') {
                formData.childSeat = 0;
            }
            else {
                formData.childSeat = v;
            }
        }
        const timeSlot = ref();
        async function loadTimeSlot() {
            const time = MainStore.time?.split(':');
            const hour = parseInt(time[0]);
            const minute = parseInt(time[1]);
            const res = await u.$http.get('front/reserve/loadTimeSlot', {
                params: {
                    storeId: MainStore.storeId,
                    // 店家時段是台北牆上時間，不可帶瀏覽器時區偏移（國外客會對不到時段）
                    time: dayjs().hour(hour).minute(minute)
                        .format('HH:mm'),
                }
            });
            timeSlot.value = res.data.data.item;
        }
        const total = computed(() => {
            let total = 0;
            formData.meals.map((v) => {
                const meal = meals.value?.find(meal => meal.id === v.id);
                const price = meal?.price * v.quantity;
                total = total + price;
            });
            formData.additionalMeals.map((v) => {
                const meal = meals.value?.find(meal => meal.id === v.id);
                const price = meal?.price * v.quantity;
                total = total + price;
            });
            return total;
        });
        const cleanFee = computed(() => {
            return total.value * 0.1;
        });
        //判斷是否台灣
        const isTaiwanPhone = computed(() => formData.countryCode === '+886');
        const grandTotal = computed(() => {
            // ✅ 非台灣手機，一律免訂金
            //先停掉 要測試付款
            /*if (!isTaiwanPhone.value) {
              return 0;
            }*/
            if (store.value?.depositType === DepositType.MEAL) {
                return total.value + cleanFee.value;
            }
            if (store.value?.depositType === DepositType.HEAD
                && formData.adult > store.value?.depositTargetHeadcount) {
                return store.value?.depositEachHeadcount * formData.adult;
            }
            return 0;
        });
        const orderPurposes = computed(() => {
            return ORDER_PURPOSE_OPTIONS;
        });
        function configureForm() {
            configure({
                generateMessage: localize({
                    en: {
                        messages: {
                            required: 'This field is required。',
                            email: 'This field must be a valid email address。',
                            emailStrict: 'Email cannot contain invalid characters (comma, space, etc.)。',
                            nameStrict: 'Name contains invalid characters。',
                            minLength: ctx => {
                                return `This field requires a minimum of ${ctx.rule?.params?.toString()} characters。`;
                            },
                            taiwanPhone: ctx => {
                                return `Invalid phone number`;
                            },
                        }
                    },
                    zh_TW: {
                        messages: {
                            required: '請填寫這個欄位。',
                            email: '該欄位須為有效的電子信箱。',
                            emailStrict: 'Email 不可包含逗號、空白或其他非法字元。',
                            nameStrict: '姓名不可包含特殊符號（僅限中英文、空白、.、-）',
                            minLength: ctx => {
                                return `該欄位最少需要 ${ctx.rule?.params?.toString()} 個字元。`;
                            },
                            minMeals: ctx => {
                                return `最少請選擇 ${ctx.rule?.params?.toString()} 份餐點。`;
                            },
                            taiwanPhone: ctx => {
                                return `手機號碼格式有誤`;
                            },
                        }
                    }
                })
            });
            defineRule('minLength', (value, [limit]) => {
                if (!value || !value.length) {
                    return true;
                }
                return value.length >= limit;
            });
            defineRule('minMeals', (value, [limit]) => {
                let val = value;
                if (!val) {
                    val = 0;
                }
                return val >= limit;
            });
            defineRule('taiwanPhone', (value, [limit]) => {
                let val = value;
                if (val?.length === 9) {
                    return val.startsWith('9');
                }
                if (val?.length === 10) {
                    return val.startsWith('09');
                }
                return true;
            });
            defineRule('emailStrict', (value) => {
                if (!value)
                    return true;
                // 禁止 RFC 常見非法字元（避免你遇到的錯誤）
                const invalidChars = /[(),:;<>[\]\s]/;
                if (invalidChars.test(value)) {
                    return false; // 會用上面 message
                }
                return true;
            });
            defineRule('nameStrict', (value) => {
                if (!value)
                    return true;
                // 允許：中文、英文、空白、點、連字號
                const valid = /^[\p{L}\s.\-]+$/u;
                if (!valid.test(value)) {
                    return false;
                }
                return true;
            });
            Object.entries(rules).forEach((value) => {
                defineRule(value[0], value[1]);
            });
            if (locale === 'en-US') {
                setLocale('en');
            }
            else {
                setLocale('zh_TW');
            }
        }
        function setMealsValue(value) {
            formData.meals = value;
        }
        function setAdditionalMealsValue(value) {
            formData.additionalMeals = value;
        }
        function setNameValue(value) {
            formData.name = value;
        }
        function setCountryCodeValue(value) {
            formData.countryCode = value;
        }
        function setPhoneValue(value) {
            formData.phone = value.replace(/^0+/, '');
        }
        function setEmailValue(value) {
            formData.email = value;
        }
        const guidelinesModal = ref();
        const modalCheckbox = ref(false);
        const showMenuLightbox = ref(false);
        const lightboxScale = ref(1);
        const lightboxTranslateX = ref(0);
        const lightboxTranslateY = ref(0);
        let lightboxBaseScale = 1;
        let lightboxBaseTranslateX = 0;
        let lightboxBaseTranslateY = 0;
        let pinchStartDist = 0;
        let panStartX = 0;
        let panStartY = 0;
        function getPinchDist(touches) {
            const dx = touches[0].clientX - touches[1].clientX;
            const dy = touches[0].clientY - touches[1].clientY;
            return Math.sqrt(dx * dx + dy * dy);
        }
        function onLightboxTouchStart(e) {
            if (e.touches.length === 2) {
                pinchStartDist = getPinchDist(e.touches);
            }
            else if (e.touches.length === 1 && lightboxScale.value > 1) {
                panStartX = e.touches[0].clientX;
                panStartY = e.touches[0].clientY;
            }
        }
        function onLightboxTouchMove(e) {
            e.preventDefault();
            if (e.touches.length === 2) {
                const ratio = getPinchDist(e.touches) / pinchStartDist;
                lightboxScale.value = Math.min(Math.max(lightboxBaseScale * ratio, 1), 5);
            }
            else if (e.touches.length === 1 && lightboxScale.value > 1) {
                lightboxTranslateX.value = lightboxBaseTranslateX + (e.touches[0].clientX - panStartX);
                lightboxTranslateY.value = lightboxBaseTranslateY + (e.touches[0].clientY - panStartY);
            }
        }
        function onLightboxTouchEnd() {
            lightboxBaseScale = lightboxScale.value;
            lightboxBaseTranslateX = lightboxTranslateX.value;
            lightboxBaseTranslateY = lightboxTranslateY.value;
            if (lightboxScale.value <= 1) {
                lightboxTranslateX.value = 0;
                lightboxTranslateY.value = 0;
                lightboxBaseTranslateX = 0;
                lightboxBaseTranslateY = 0;
            }
        }
        function onLightboxWheel(e) {
            e.preventDefault();
            const delta = e.deltaY > 0 ? 0.9 : 1.1;
            lightboxScale.value = Math.min(Math.max(lightboxScale.value * delta, 1), 5);
            lightboxBaseScale = lightboxScale.value;
            if (lightboxScale.value <= 1) {
                lightboxTranslateX.value = 0;
                lightboxTranslateY.value = 0;
                lightboxBaseTranslateX = 0;
                lightboxBaseTranslateY = 0;
            }
        }
        let isDragging = false;
        function onLightboxMouseDown(e) {
            if (lightboxScale.value <= 1)
                return;
            isDragging = true;
            panStartX = e.clientX;
            panStartY = e.clientY;
        }
        function onLightboxMouseMove(e) {
            if (!isDragging)
                return;
            lightboxTranslateX.value = lightboxBaseTranslateX + (e.clientX - panStartX);
            lightboxTranslateY.value = lightboxBaseTranslateY + (e.clientY - panStartY);
        }
        function onLightboxMouseUp() {
            if (!isDragging)
                return;
            isDragging = false;
            lightboxBaseTranslateX = lightboxTranslateX.value;
            lightboxBaseTranslateY = lightboxTranslateY.value;
        }
        function preventZoom(e) {
            if (e.touches.length > 1)
                e.preventDefault();
        }
        watch(showMenuLightbox, (val) => {
            if (val) {
                lightboxScale.value = 1;
                lightboxBaseScale = 1;
                lightboxTranslateX.value = 0;
                lightboxTranslateY.value = 0;
                lightboxBaseTranslateX = 0;
                lightboxBaseTranslateY = 0;
                document.documentElement.style.overflow = 'hidden';
                document.body.style.overflow = 'hidden';
                document.addEventListener('touchmove', preventZoom, { passive: false });
                document.addEventListener('wheel', onLightboxWheel, { passive: false });
            }
            else {
                document.documentElement.style.overflow = '';
                document.body.style.overflow = '';
                document.removeEventListener('touchmove', preventZoom);
                document.removeEventListener('wheel', onLightboxWheel);
            }
        });
        const showMenuImage = computed(() => brand.value?.tw?.title === '明水然・樂');
        // 菜單圖依語系切換：中文版 reservation_menu.jpg、英文版 reservation_menu_en.jpg
        // MENU_IMAGE_VERSION：每次「換菜單圖」時把這個數字 +1，URL 帶 ?v= 可避免瀏覽器吃到舊快取
        const menuImageSrc = computed(() => {
            const file = locale === 'zh-TW'
                ? 'reservation_menu.jpg'
                : 'reservation_menu_en.jpg';
            return `/assets/images/front/reservation-form/${file}?v=${MENU_IMAGE_VERSION}`;
        });
        const form = useForm();
        const showInput = computed(() => {
            return !!store.value; // meals 永遠是 []，不需要判斷
        });
        async function openModal() {
            if (!await validationForm()) {
                return false;
            }
            submitError.value = false;
            submitErrorMessage.value = '';
            if (!await precheckBeforeOpenModal()) {
                return false;
            }
            getModalInstance()?.show();
        }
        async function validationForm() {
            const res = await form.validate();
            if (!res.valid) {
                const firstErrorField = Object.keys(res.errors)[0];
                const el = document.querySelector(`[name="${firstErrorField}"]`);
                const body = document.querySelector('body');
                let ratio = 140;
                if (body.clientWidth < 992) {
                    ratio = 110;
                }
                window.scrollTo({
                    top: Math.abs(body.getBoundingClientRect().top - el.getBoundingClientRect().top) - ratio,
                    behavior: 'smooth'
                });
                return false;
            }
            return true;
        }
        function getModalInstance() {
            return bootstrap.Modal.getOrCreateInstance(guidelinesModal.value);
        }
        function getOtpModalInstance() {
            return bootstrap.Modal.getOrCreateInstance(otpModal.value);
        }
        function getCaptchaModalInstance() {
            return bootstrap.Modal.getOrCreateInstance(captchaModal.value);
        }
        // 訂位須知四欄：優先讀「該門店」內容，門店該欄為空才回退「品牌」內容（依當前語系）
        function pickNotice(field) {
            const key = locale === 'zh-TW' ? 'tw' : 'en';
            const storeVal = store.value?.[key]?.[field] ?? '';
            if (storeVal !== '') {
                return storeVal;
            }
            return brand.value?.[key]?.[field] ?? '';
        }
        const modalReservationInstruction = computed(() => pickNotice('reservationInstruction'));
        const modalPrepaidFee = computed(() => pickNotice('prepaidFee'));
        const modalRefundPolicy = computed(() => pickNotice('refundPolicy'));
        const modalNotice = computed(() => pickNotice('notice'));
        const disabledInput = ref(false);
        const submitError = ref(false);
        const duplicateModal = ref();
        const storeList = ref([]);
        const otpModal = ref();
        const otpVerificationId = ref('');
        const otpCode = ref('');
        const otpError = ref('');
        const otpSending = ref(false);
        const otpVerifying = ref(false);
        const otpResendIn = ref(0);
        const otpExpiresIn = ref(0);
        const otpTimer = ref(null);
        const otpFailedCount = ref(0);
        const otpMaxFailedCount = ref(5);
        // 本次「發送」是否失敗（用來避免在重送失敗時，標題還掛著「已發送」造成矛盾畫面）
        const otpSendFailed = ref(false);
        // 後端因簡訊失敗自動 fallback 到 Email 時為 true，用來提示客人改查信箱
        const otpFallbackToEmail = ref(false);
        const pendingSubmitToken = ref('');
        const pendingFinalSubmitAfterOtp = ref(false);
        const pendingOtpResend = ref(false);
        /**
         * Email 必填與否依國碼：+886 本國客選填（2026-09-10 需求），外國客仍必填。
         *
         * 外國客不放寬不是體感問題，是流程會斷：他們的驗證碼只有 Email 一條路
         * （後端 otpChannel() 對非 +886 一律回 email），訂位通知也寄不到國外門號。
         * 後端 ReserveController::validateReservationEmailOrFail() 是同一套判定，
         * 改這裡務必連後端一起改，否則前端放行、送出才被擋。
         */
        const emailRequired = computed(() => formData.countryCode !== '+886');
        const emailRules = computed(() => (emailRequired.value ? 'required|email|emailStrict' : 'email|emailStrict'));
        const verificationType = ref(null);
        const submitLocked = ref(false);
        const captchaModal = ref();
        const captchaVerificationId = ref('');
        const captchaCode = ref('');
        const captchaImageData = ref('');
        const captchaError = ref('');
        const captchaLoading = ref(false);
        const captchaVerifying = ref(false);
        const captchaExpiresIn = ref(0);
        const captchaTimer = ref(null);
        const captchaFailedCount = ref(0);
        const captchaMaxFailedCount = ref(5);
        const pendingCaptchaRefresh = ref(false);
        function syncPaymentRule() {
            const isTw = formData.countryCode === '+886';
            formData.paymentType = isTw ? PaymentType.WEB_ATM : PaymentType.CREDIT_CARD;
            // ✅ 外國客必走線上付款
            formData.noOnlinePayment = false;
            //formData.noOnlinePayment = !isTw;
            //formData.skipDeposit = !isTw;
        }
        watch(() => formData.countryCode, syncPaymentRule, { immediate: true });
        function clearOtpTimer() {
            if (otpTimer.value !== null) {
                window.clearInterval(otpTimer.value);
                otpTimer.value = null;
            }
        }
        function clearCaptchaTimer() {
            if (captchaTimer.value !== null) {
                window.clearInterval(captchaTimer.value);
                captchaTimer.value = null;
            }
        }
        function startOtpTimer() {
            clearOtpTimer();
            otpTimer.value = window.setInterval(() => {
                if (otpResendIn.value > 0) {
                    otpResendIn.value -= 1;
                }
                if (otpExpiresIn.value > 0) {
                    otpExpiresIn.value -= 1;
                }
                if (otpExpiresIn.value <= 0 && otpTimer.value !== null) {
                    clearOtpTimer();
                }
            }, 1000);
        }
        function startCaptchaTimer() {
            clearCaptchaTimer();
            captchaTimer.value = window.setInterval(() => {
                if (captchaExpiresIn.value > 0) {
                    captchaExpiresIn.value -= 1;
                }
                if (captchaExpiresIn.value <= 0 && captchaTimer.value !== null) {
                    clearCaptchaTimer();
                }
            }, 1000);
        }
        function resetOtpState() {
            otpVerificationId.value = '';
            otpCode.value = '';
            otpError.value = '';
            otpSending.value = false;
            otpVerifying.value = false;
            otpResendIn.value = 0;
            otpExpiresIn.value = 0;
            pendingSubmitToken.value = '';
            pendingFinalSubmitAfterOtp.value = false;
            pendingOtpResend.value = false;
            verificationType.value = null;
            formData.otpVerifiedToken = '';
            otpFailedCount.value = 0;
            otpSendFailed.value = false;
            otpFallbackToEmail.value = false;
            submitLocked.value = false;
            clearOtpTimer();
        }
        function resetCaptchaState() {
            captchaVerificationId.value = '';
            captchaCode.value = '';
            captchaImageData.value = '';
            captchaError.value = '';
            captchaLoading.value = false;
            captchaVerifying.value = false;
            captchaExpiresIn.value = 0;
            captchaFailedCount.value = 0;
            formData.captchaVerifiedToken = '';
            clearCaptchaTimer();
        }
        watch(() => formData.countryCode, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                resetOtpState();
                resetCaptchaState();
            }
        });
        watch(() => formData.phone, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                resetOtpState();
                resetCaptchaState();
            }
        });
        watch(() => formData.email, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                resetOtpState();
                resetCaptchaState();
            }
        });
        // 檢查金流是否可用
        async function checkPaymentAvailable() {
            try {
                const res = await u.$http.get('front/reserve/checkPaymentAvailable');
                return res.data?.data ?? res.data ?? { ok: false, message: '檢查系統狀態失敗' };
            }
            catch (e) {
                return {
                    ok: false,
                    message: e?.response?.data?.message || e?.message || '檢查系統狀態失敗',
                };
            }
        }
        async function ensurePaymentAvailableIfNeeded() {
            if (!grandTotal.value) {
                return true;
            }
            const paymentAvailable = await checkPaymentAvailable();
            if (!paymentAvailable.ok) {
                submitErrorMessage.value =
                    paymentAvailable.message || '目前系統維護中，請稍後再試，或於門店營業時間致電';
                submitError.value = true;
                return false;
            }
            return true;
        }
        async function precheckBeforeOpenModal() {
            if (!grandTotal.value) {
                return true;
            }
            const paymentAvailable = await checkPaymentAvailable();
            if (!paymentAvailable.ok) {
                alert(paymentAvailable.message || '目前系統維護中，請稍後再試，或於門店營業時間致電');
                return false;
            }
            return true;
        }
        async function submitForm(token) {
            const btn = document.querySelector('.g-recaptcha');
            if (btn)
                btn.disabled = true;
            formData.storeId = store.value?.id;
            formData.timeSlotId = timeSlot.value?.id;
            // 訂位時間是台北牆上時間，固定 +08:00，不可用瀏覽器時區（國外客會存錯時間/對不到時段）
            formData.date = dayjs(`${MainStore.date} ${MainStore.time}`).format('YYYY-MM-DD HH:mm') + '+08:00';
            formData.gRecaptchaResponse = token;
            syncPaymentRule();
            try {
                if (pendingCaptchaRefresh.value) {
                    pendingCaptchaRefresh.value = false;
                    await createCaptchaChallenge();
                    return;
                }
                if (pendingOtpResend.value) {
                    pendingOtpResend.value = false;
                    const sent = await sendOtpCode();
                    if (!sent) {
                        return;
                    }
                    return;
                }
                if (pendingFinalSubmitAfterOtp.value && formData.otpVerifiedToken) {
                    pendingFinalSubmitAfterOtp.value = false;
                    if (!await ensurePaymentAvailableIfNeeded()) {
                        return;
                    }
                    await submitReservation();
                    return;
                }
                if (!modalCheckbox.value) {
                    return;
                }
                const eligibility = await checkBookingEligibility();
                //console.log('eligibility =', eligibility);
                if (eligibility.blocked) {
                    submitErrorMessage.value = eligibility.blockMessage || '此手機目前無法訂位';
                    submitError.value = true;
                    return;
                }
                verificationType.value = eligibility.verificationType ?? null;
                if (eligibility.requiresVerification && verificationType.value === 'captcha' && !formData.captchaVerifiedToken) {
                    pendingFinalSubmitAfterOtp.value = true;
                    const created = await createCaptchaChallenge();
                    if (!created) {
                        pendingFinalSubmitAfterOtp.value = false;
                        submitLocked.value = false;
                        return;
                    }
                    await nextTick();
                    if (!captchaVerificationId.value) {
                        return;
                    }
                    getCaptchaModalInstance().show();
                    return;
                }
                if (eligibility.requiresVerification
                    && verificationType.value !== 'captcha'
                    && !formData.otpVerifiedToken) {
                    pendingFinalSubmitAfterOtp.value = true;
                    const sent = await sendOtpCode();
                    if (!sent) {
                        pendingFinalSubmitAfterOtp.value = false;
                        // 首次發送失敗：錯誤原本只寫進 otpError，而驗證碼視窗根本還沒打開，客人看不到任何訊息；
                        // submitLocked 又沒有人還原，「確認」鈕永久 disabled（2026-10-13 驗收報告第 4 節）。
                        // 改在須知視窗直接顯示錯誤（冷卻中那條已自行設好 submitError，不覆蓋）。
                        if (!submitError.value) {
                            submitErrorMessage.value = otpError.value || $lang('app.reservation.otp.error.send.failed');
                            submitError.value = true;
                        }
                        submitLocked.value = false;
                        return;
                    }
                    await nextTick();
                    if (!otpVerificationId.value) {
                        return; // 不開 modal
                    }
                    getOtpModalInstance().show();
                    return;
                }
                if (!await ensurePaymentAvailableIfNeeded()) {
                    return;
                }
                await submitReservation();
            }
            catch (e) {
                submitErrorMessage.value = submitFailureMessage(e);
                submitError.value = true;
                submitLocked.value = false;
            }
            finally {
                if (btn)
                    btn.disabled = false;
            }
        }
        /**
         * 送出失敗要給客人看的話。
         *
         * 沒拿到回應（逾時、斷網）＝請求可能已經到後端、訂位也建好了，只是回應沒回來。
         * 這時說「訂位失敗」客人會直接重訂，變成重複訂位；要請他先用訂位查詢確認。
         * 有回應就照後端給的訊息（例：時段已滿）。
         */
        function submitFailureMessage(e) {
            if (!e?.response) {
                return $lang('app.reservation.form.error.uncertain');
            }
            return e?.response?.data?.message || e?.message || '送出失敗';
        }
        async function submitReservation() {
            //console.log('[submitReservation] otpVerifiedToken before post =', formData.otpVerifiedToken);
            //console.log('[submitReservation] phone =', formData.phone);
            //console.log('[submitReservation] countryCode =', formData.countryCode);
            try {
                disabledInput.value = true;
                const isDuplicate = await checkCustomerDuplicateBooking();
                if (isDuplicate) {
                    storeList.value = [];
                    const storeRes = await u.$http.get('front/store/brand/list', {
                        params: {
                            locale: locale,
                            store_id: MainStore.storeId,
                        }
                    });
                    storeList.value.push(...storeRes.data.data);
                    await getModalInstance().hide();
                    await getDuplicateModalInstance().show();
                    return;
                }
                const res = await u.$http.post('front/reserve/reserving', {
                    data: formData
                });
                disabledInput.value = false;
                const redirectUrl = res.data?.data?.redirectUrl ?? res.data?.redirectUrl;
                //console.log('[reserve] full response =', res.data);
                //console.log('[reserve] redirectUrl =', redirectUrl);
                if (redirectUrl) {
                    // 訂位成功埋點（下單當下，非付款完成）：
                    //   GA4  → 事件 booking_success（區分「瀏覽 vs 下訂」；評估 ID 走 .env）
                    //   Meta → Pixel 標準事件 Purchase（廣告帳號的轉換最佳化目標設在標準事件）
                    // gtag 用 event_callback + 1 秒 fallback 保險送出再導頁；fbq 走 sendBeacon 可跨頁面存活。
                    let navigated = false;
                    const go = () => {
                        if (navigated)
                            return;
                        navigated = true;
                        window.location.href = redirectUrl;
                    };
                    try {
                        const setMenu = formData.meals
                            .map((v) => meals.value?.find((m) => m.id === v.id)?.tw.title ?? '')
                            .filter(Boolean)
                            .join(', ');
                        const storeName = store.value?.tw.title ?? '';
                        const partySize = (formData.adult ?? 0) + (formData.child ?? 0);
                        const bookingDate = dayjs(MainStore.date).format('YYYY-MM-DD');
                        const orderValue = total.value;
                        // 訂單編號：後端 reserving 回應本就帶 order.no（框架會多包一層 data，故 data.data）
                        const orderNo = res.data?.data?.order?.no ?? res.data?.order?.no ?? '';
                        const brand = 'minsuizen';
                        // 前端第一層防重：同一訂位編號在本 session 只送一次。
                        // 這攔不到跨裝置／清快取的重複，故三個平台一律帶訂位編號當去重鍵
                        // （Meta 的 eventID、TikTok 的 event_id、GA4 的 transaction_id），由平台端兜底。
                        let alreadySent = false;
                        try {
                            if (orderNo) {
                                alreadySent = sessionStorage.getItem('bs_' + orderNo) === '1';
                                sessionStorage.setItem('bs_' + orderNo, '1');
                            }
                        }
                        catch (e) {
                            // 隱私模式等情境下 sessionStorage 不可用：放行送出，重複交給平台端去重
                        }
                        const payload = {
                            brand: brand,
                            store: storeName,
                            party_size: partySize,
                            booking_date: bookingDate,
                            set_menu: setMenu,
                            value: orderValue,
                            currency: 'TWD',
                            order_no: orderNo,
                        };
                        // Meta Pixel：標準事件 Purchase。
                        // 沿革：原為標準 Purchase → 1.5.0.7 起改成自訂事件 booking_success 與 GA4 同口徑
                        // → 2026-08-10 行銷部確認廣告帳號的轉換最佳化目標設在標準 Purchase，
                        //    自訂事件收不到轉換訊號，故改回 track/Purchase（九月肉多多沿用同一套）。
                        // ⚠️ 此處不可再改成 trackCustom；GA4 維持 booking_success、TikTok 維持 PlaceAnOrder。
                        // value 一律帶實際金額（行銷部代碼包寫死 0 會讓 ROAS 算不出來），eventID 帶訂位編號去重。
                        const fbq = window.fbq;
                        if (!alreadySent && typeof fbq === 'function') {
                            fbq('track', 'Purchase', payload, orderNo ? { eventID: orderNo } : undefined);
                        }
                        // TikTok Pixel：標準事件 PlaceAnOrder（行銷部指定），event_id 帶訂位編號去重
                        const ttq = window.ttq;
                        if (!alreadySent && ttq && typeof ttq.track === 'function') {
                            ttq.track('PlaceAnOrder', {
                                content_id: brand + '_' + storeName,
                                content_name: storeName,
                                currency: 'TWD',
                                value: orderValue,
                            }, orderNo ? { event_id: orderNo } : undefined);
                        }
                        const gtag = window.gtag;
                        if (!alreadySent && typeof gtag === 'function') {
                            gtag('event', 'booking_success', {
                                ...payload,
                                transaction_id: orderNo,
                                event_callback: go,
                            });
                            setTimeout(go, 1000);
                        }
                        else {
                            // 埋點未載入（測試區網域／擋廣告外掛）或本單已送過：直接導頁，不可卡住訂位流程
                            go();
                        }
                    }
                    catch (e) {
                        go();
                    }
                    return;
                }
                submitError.value = true;
            }
            catch (e) {
                submitErrorMessage.value = submitFailureMessage(e);
                submitError.value = true;
            }
            finally {
                disabledInput.value = false;
            }
        }
        function back() {
            emits('toSearchList');
        }
        const submitErrorMessage = ref('');
        async function hideModalAndBack() {
            submitError.value = false;
            submitErrorMessage.value = '';
            await getModalInstance().hide();
            await back();
        }
        function loadRecaptcha() {
            const script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit';
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
            // 當 reCAPTCHA 完成載入後，手動 render 按鈕
            window.onRecaptchaLoad = () => {
                const grecaptcha = window.grecaptcha;
                const container = document.getElementById('g-recaptcha-container');
                if (container && grecaptcha && recaptchaWidgetId === null) {
                    recaptchaWidgetId = grecaptcha.render(container, {
                        sitekey: rcKey,
                        size: 'invisible',
                        callback: (token) => {
                            clearRecaptchaGuard();
                            submitForm(token);
                        },
                        'error-callback': () => {
                            failRecaptcha(recaptchaPurpose, 'load');
                        },
                        'expired-callback': () => {
                            failRecaptcha(recaptchaPurpose, 'timeout');
                        },
                    });
                }
            };
        }
        // reCAPTCHA 最長等 120 秒（v1.8.7.3 驗收第 4 節；與寫入類請求同一把尺，也留時間給客人解圖片題）。
        // 原本只有成功的 callback：腳本被擋時按「確認」完全沒反應；驗證後送單那一步
        // （驗證碼通過後的最後送出）拿不到回應時，「確認」鈕永久 disabled、沒有任何訊息。
        // 現在一律經過 runRecaptcha()：沒載入、出錯、過期或逾時沒結果都解鎖並顯示原因。
        let recaptchaGuardTimer = null;
        let recaptchaPurpose = 'submit';
        function clearRecaptchaGuard() {
            if (recaptchaGuardTimer !== null) {
                window.clearTimeout(recaptchaGuardTimer);
                recaptchaGuardTimer = null;
            }
        }
        function runRecaptcha(purpose) {
            const grecaptcha = window.grecaptcha;
            if (!grecaptcha || recaptchaWidgetId === null) {
                failRecaptcha(purpose, 'load');
                return false;
            }
            recaptchaPurpose = purpose;
            clearRecaptchaGuard();
            recaptchaGuardTimer = window.setTimeout(() => {
                failRecaptcha(purpose, 'timeout');
            }, RECAPTCHA_TIMEOUT_MS);
            try {
                grecaptcha.execute(recaptchaWidgetId);
            }
            catch (e) {
                failRecaptcha(purpose, 'load');
                return false;
            }
            return true;
        }
        function failRecaptcha(purpose, reason) {
            clearRecaptchaGuard();
            const grecaptcha = window.grecaptcha;
            if (grecaptcha && recaptchaWidgetId !== null) {
                try {
                    // 重設後下一次 execute 才會重新出題，避免沿用卡住的那一輪
                    grecaptcha.reset(recaptchaWidgetId);
                }
                catch (e) {
                    // 重設失敗不影響解鎖
                }
            }
            // pendingFinalSubmitAfterOtp 刻意保留：驗證碼已通過，客人再按一次「確認」就直接送單
            pendingCaptchaRefresh.value = false;
            pendingOtpResend.value = false;
            submitLocked.value = false;
            const message = $lang(reason === 'timeout'
                ? 'app.reservation.recaptcha.error.timeout'
                : 'app.reservation.recaptcha.error.load');
            if (purpose === 'otp') {
                otpError.value = message;
                return;
            }
            if (purpose === 'captcha') {
                captchaError.value = message;
                return;
            }
            submitErrorMessage.value = message;
            submitError.value = true;
        }
        function toVerify() {
            if (submitLocked.value) {
                return;
            }
            submitLocked.value = true;
            // 沒載入／失敗時 runRecaptcha 會解鎖並顯示原因
            runRecaptcha('submit');
        }
        function getDuplicateModalInstance() {
            return bootstrap.Modal.getOrCreateInstance(duplicateModal.value);
        }
        async function checkCustomerDuplicateBooking() {
            const res = await u.$http.get('front/reserve/checkCustomerDuplicateBooking', {
                params: {
                    country_code: formData.countryCode,
                    phone: formData.phone,
                    store_id: MainStore.storeId,
                    date: formData.date,
                }
            });
            return res.data.data;
        }
        async function checkBookingEligibility() {
            const res = await u.$http.get('front/reserve/checkBookingEligibility', {
                params: {
                    country_code: formData.countryCode,
                    phone: formData.phone,
                    date: formData.date,
                    email: formData.email,
                    // name 照送：contactChanged（改名就重驗）已於 api 1.7.3.0 停用，
                    // 後端只是收下不再用它判定。留著是為了「前後台送的欄位一致」，
                    // 日後要恢復那條規則時不必再繞一次前端。
                    name: formData.name,
                }
            });
            //console.log('[checkBookingEligibility] raw =', res.data);
            return res.data?.data?.data ?? res.data?.data ?? {};
        }
        async function sendOtpCode() {
            otpError.value = '';
            otpSendFailed.value = false;
            otpSending.value = true;
            if (!formData.storeId) {
                formData.storeId = store.value?.id;
            }
            if (!formData.date) {
                // 訂位時間是台北牆上時間，固定 +08:00，不可用瀏覽器時區（國外客會存錯時間/對不到時段）
                formData.date = dayjs(`${MainStore.date} ${MainStore.time}`).format('YYYY-MM-DD HH:mm') + '+08:00';
            }
            try {
                const api = verificationType.value === 'email'
                    ? 'front/reserve/sendEmailOtp'
                    : 'front/reserve/sendOtp';
                // verificationId：首次發送是空字串，重發時是上一組的 id。
                // 後端（api 1.7.2.2 起）拿它辨識「這是同一次訂位流程的重寄」，不看該碼是否
                // 已過期或已消費。少了它，+886 客在簡訊寄不出、改走 Email 驗證之後，只要在
                // 驗證視窗停留超過一小時（或驗證通過但建單失敗），按重發就會被
                // 「台灣手機不使用 Email 驗證」擋死，而且在那個視窗按幾次都一樣。
                const payload = verificationType.value === 'email'
                    ? {
                        email: formData.email,
                        countryCode: formData.countryCode,
                        phone: formData.phone,
                        date: formData.date,
                        name: formData.name,
                        verificationId: otpVerificationId.value,
                        gRecaptchaResponse: formData.gRecaptchaResponse,
                        language: locale,
                    }
                    : {
                        countryCode: formData.countryCode,
                        phone: formData.phone,
                        date: formData.date,
                        email: formData.email,
                        name: formData.name,
                        verificationId: otpVerificationId.value,
                        gRecaptchaResponse: formData.gRecaptchaResponse,
                        language: locale,
                    };
                const res = await u.$http.post(api, { data: payload });
                const response = res.data ?? {};
                const data = response.data?.data ?? response.data ?? {};
                if (!response.success) {
                    otpSendFailed.value = true;
                    otpError.value = response.message || $lang('app.reservation.otp.error.send.failed');
                    return false;
                }
                if (!data.ok) {
                    // 冷卻未過不是失敗：驗證碼還在客人手上、session 也還沒過期，
                    // 這裡若清掉狀態會連 verificationId 一起丟掉，等冷卻結束再按重發時，
                    // 後端就認不回這是同一次流程，又會掉回「不使用 Email 驗證」的死路。
                    if (data.code === 'OTP_RESEND_TOO_FREQUENT') {
                        submitErrorMessage.value = $lang('app.reservation.otp.error.resend.blocked');
                        submitError.value = true;
                        return false;
                    }
                    // 真的失敗才清掉舊 OTP
                    resetOtpState();
                    otpSendFailed.value = true;
                    // blocked 的理由在 blockMessage（message 這個鍵不存在），讀錯會把
                    // 「訂位已達上限」之類的具體原因蓋成一句籠統的發送失敗。
                    otpError.value = data.blockMessage
                        || data.message
                        || $lang('app.reservation.otp.error.send.failed');
                    return false;
                }
                // 同步後端「實際使用的驗證管道」：簡訊失敗時後端會自動 fallback 到 Email，
                // 此時 verificationType 會變成 'email'，前端必須跟著切換，
                // 否則標題、提示與後續驗證 API 都會停在 'sms' 而對不上實際情況。
                const sentVia = data.verificationType ?? data.verification_type;
                if (sentVia === 'sms' || sentVia === 'email') {
                    verificationType.value = sentVia;
                }
                otpFallbackToEmail.value = (data.fallbackTo ?? data.fallback_to) === 'email';
                otpVerificationId.value = data.verificationId ?? data.verification_id ?? '';
                otpResendIn.value = Number(data.resendIn ?? data.resend_in ?? 0);
                otpExpiresIn.value = Number(data.expiresIn ?? data.expires_in ?? 0);
                otpFailedCount.value = 0;
                if (!otpVerificationId.value) {
                    otpSendFailed.value = true;
                    otpError.value = data.message || $lang('app.reservation.otp.error.send.failed');
                    return false;
                }
                otpCode.value = '';
                startOtpTimer();
                return true;
            }
            catch (e) {
                otpSendFailed.value = true;
                // 沒拿到回應（逾時、斷網）時 e.message 是 axios 的英文「Network Error」，客人看不懂，改用白話
                otpError.value = e?.response
                    ? (e.response.data?.message || e?.message || $lang('app.reservation.otp.error.send.failed'))
                    : $lang('app.reservation.form.error.network');
                return false;
            }
            finally {
                otpSending.value = false;
            }
        }
        async function createCaptchaChallenge() {
            captchaError.value = '';
            captchaLoading.value = true;
            if (!formData.storeId) {
                formData.storeId = store.value?.id;
            }
            if (!formData.date) {
                // 訂位時間是台北牆上時間，固定 +08:00，不可用瀏覽器時區（國外客會存錯時間/對不到時段）
                formData.date = dayjs(`${MainStore.date} ${MainStore.time}`).format('YYYY-MM-DD HH:mm') + '+08:00';
            }
            try {
                const res = await u.$http.post('front/reserve/createCaptcha', {
                    data: {
                        countryCode: formData.countryCode,
                        phone: formData.phone,
                        date: formData.date,
                        email: formData.email,
                        name: formData.name,
                        gRecaptchaResponse: formData.gRecaptchaResponse,
                    }
                });
                const response = res.data ?? {};
                const data = response.data?.data ?? response.data ?? {};
                if (!response.success) {
                    captchaError.value = response.message || '取得圖形驗證失敗';
                    return false;
                }
                if (!data.ok) {
                    captchaError.value = data.message || '取得圖形驗證失敗';
                    return false;
                }
                captchaVerificationId.value = data.verificationId ?? '';
                captchaImageData.value = data.imageData ?? '';
                captchaExpiresIn.value = Number(data.expiresIn ?? 0);
                captchaCode.value = '';
                captchaFailedCount.value = 0;
                if (!captchaVerificationId.value || !captchaImageData.value) {
                    captchaError.value = data.message || '取得圖形驗證失敗';
                    return false;
                }
                startCaptchaTimer();
                return true;
            }
            catch (e) {
                captchaError.value = e?.response?.data?.message || e?.message || '取得圖形驗證失敗';
                return false;
            }
            finally {
                captchaLoading.value = false;
            }
        }
        async function verifyCaptchaCode() {
            formData.captchaVerifiedToken = '';
            if (!captchaVerificationId.value) {
                resetCaptchaState();
                captchaError.value = '圖形驗證已失效，請重新取得';
                return;
            }
            if (!captchaCode.value.trim()) {
                captchaError.value = '請輸入圖形驗證碼';
                return;
            }
            captchaError.value = '';
            captchaVerifying.value = true;
            try {
                const res = await u.$http.post('front/reserve/verifyCaptcha', {
                    data: {
                        verificationId: captchaVerificationId.value,
                        captcha: captchaCode.value.trim(),
                    }
                });
                const response = res.data ?? {};
                const data = response.data?.data ?? response.data ?? {};
                if (!response.success || !data.ok) {
                    captchaFailedCount.value += 1;
                    captchaError.value = data.message || response.message || '圖形驗證失敗';
                    return;
                }
                formData.captchaVerifiedToken =
                    data.captchaVerifiedToken ??
                        data.token ??
                        '';
                if (!formData.captchaVerifiedToken) {
                    captchaError.value = '圖形驗證憑證遺失';
                    return;
                }
                clearCaptchaTimer();
                await getCaptchaModalInstance().hide();
                if (pendingFinalSubmitAfterOtp.value) {
                    runRecaptcha('submit');
                }
            }
            catch (e) {
                captchaFailedCount.value += 1;
                captchaError.value = e?.response?.data?.message || e?.message || '圖形驗證失敗';
            }
            finally {
                captchaVerifying.value = false;
            }
        }
        async function verifyOtpCode() {
            formData.otpVerifiedToken = '';
            if (!otpVerificationId.value) {
                resetOtpState();
                otpError.value = $lang('app.reservation.otp.error.flow.expired');
                return;
            }
            if (!otpCode.value.trim()) {
                otpError.value = $lang('app.reservation.otp.error.missing.code');
                return;
            }
            otpError.value = '';
            otpVerifying.value = true;
            try {
                const isEmailVerification = verificationType.value === 'email';
                const url = isEmailVerification
                    ? 'front/reserve/verifyEmailOtp'
                    : 'front/reserve/verifyOtp';
                const payload = isEmailVerification
                    ? {
                        verificationId: otpVerificationId.value,
                        email: formData.email,
                        otp: otpCode.value.trim(),
                    }
                    : {
                        verificationId: otpVerificationId.value,
                        countryCode: formData.countryCode,
                        phone: formData.phone,
                        otp: otpCode.value.trim(),
                    };
                const res = await u.$http.post(url, { data: payload });
                const response = res.data ?? {};
                const data = response.data?.data ?? response.data ?? {};
                if (!response.success) {
                    otpFailedCount.value += 1;
                    if (otpFailedCount.value >= otpMaxFailedCount.value) {
                        otpError.value = $lang('app.reservation.otp.error.verify.limit');
                    }
                    else {
                        otpError.value = response.message || $lang('app.reservation.otp.error.verify.failed');
                    }
                    return;
                }
                if (!data.ok) {
                    otpFailedCount.value += 1;
                    if (otpFailedCount.value >= otpMaxFailedCount.value) {
                        otpError.value = $lang('app.reservation.otp.error.verify.limit');
                    }
                    else {
                        otpError.value = data.message || $lang('app.reservation.otp.error.verify.failed');
                    }
                    return;
                }
                formData.otpVerifiedToken =
                    data.otpVerifiedToken ??
                        data.token ??
                        data.verifiedToken ??
                        '';
                if (!formData.otpVerifiedToken) {
                    otpError.value = $lang('app.reservation.otp.error.token.missing');
                    return;
                }
                otpError.value = '';
                clearOtpTimer();
                await getOtpModalInstance().hide();
                if (pendingFinalSubmitAfterOtp.value) {
                    runRecaptcha('submit');
                }
            }
            catch (e) {
                //console.error('[verifyOtp] error =', e);
                //console.error('[verifyOtp] error.response =', e?.response?.data);
                const msg = e?.response?.data?.message || e?.message;
                if (msg?.includes('OTP') || msg?.includes('驗證碼')) {
                    otpFailedCount.value += 1;
                    if (otpFailedCount.value >= otpMaxFailedCount.value) {
                        otpError.value = $lang('app.reservation.otp.error.verify.limit');
                        return;
                    }
                }
                otpError.value = e?.response
                    ? (e.response.data?.message || e?.message || $lang('app.reservation.otp.error.verify.failed'))
                    : $lang('app.reservation.form.error.network');
            }
            finally {
                otpVerifying.value = false;
            }
        }
        async function hideDuplicateModalAndBack() {
            await getDuplicateModalInstance().hide();
            await back();
        }
        const genderOptions = computed(() => ([
            { text: $lang('app.reservation.gender.other'), value: 0 },
            { text: $lang('app.reservation.gender.male'), value: 1 },
            { text: $lang('app.reservation.gender.female'), value: 2 },
        ]));
        function setGenderValue(v) {
            formData.gender = Number(v);
        }
        /*
        async function hideOtpModal() {
          otpVerificationId.value = '';
          otpCode.value = '';
          otpError.value = '';
          pendingSubmitToken.value = '';
          pendingFinalSubmitAfterOtp.value = false;
          pendingOtpResend.value = false;
          verificationType.value = null;
          formData.otpVerifiedToken = '';
          otpResendIn.value = 0;
          otpExpiresIn.value = 0;
          clearOtpTimer();
          await getOtpModalInstance().hide();
        }*/
        async function hideOtpModal() {
            resetOtpState();
            submitLocked.value = false;
            const modal = getOtpModalInstance();
            const modalEl = otpModal.value;
            if (modal && modalEl) {
                modalEl.addEventListener('hidden.bs.modal', async () => {
                    // 🔥 清 backdrop
                    document.body.classList.remove('modal-open');
                    document.body.style.removeProperty('overflow');
                    document.body.style.removeProperty('padding-right');
                    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                    await back();
                }, { once: true });
                modal.hide();
                return;
            }
            await back();
        }
        async function hideCaptchaModal() {
            resetCaptchaState();
            submitLocked.value = false;
            const modal = getCaptchaModalInstance();
            const modalEl = captchaModal.value;
            if (modal && modalEl) {
                modalEl.addEventListener('hidden.bs.modal', async () => {
                    document.body.classList.remove('modal-open');
                    document.body.style.removeProperty('overflow');
                    document.body.style.removeProperty('padding-right');
                    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                    await back();
                }, { once: true });
                modal.hide();
                return;
            }
            await back();
        }
        function refreshCaptchaWithRecaptcha() {
            pendingCaptchaRefresh.value = true;
            const grecaptcha = window.grecaptcha;
            if (grecaptcha && recaptchaWidgetId !== null) {
                runRecaptcha('captcha');
            }
            else {
                pendingCaptchaRefresh.value = false;
                createCaptchaChallenge();
            }
        }
        function resendOtpWithRecaptcha() {
            if (!otpVerificationId.value) {
                resetOtpState(); // 🔥 防呆
            }
            pendingOtpResend.value = true;
            runRecaptcha('otp');
        }
        const otpModalTitle = computed(() => {
            return verificationType.value === 'email'
                ? $lang('app.reservation.otp.modal.title.email')
                : $lang('app.reservation.otp.modal.title.sms');
        });
        const otpTargetText = computed(() => {
            return verificationType.value === 'email'
                ? formData.email
                : `${formData.countryCode} ${formData.phone}`;
        });
        const otpVerifyDisabled = computed(() => {
            return otpVerifying.value || !otpCode.value || otpFailedCount.value >= otpMaxFailedCount.value;
        });
        const captchaVerifyDisabled = computed(() => {
            return captchaVerifying.value || !captchaCode.value || captchaFailedCount.value >= captchaMaxFailedCount.value;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("section", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref($lang)('app.reservation.info.intro')), 1),
                                _createElementVNode("p", _hoisted_6, [
                                    _createTextVNode(_toDisplayString(_unref($lang)('app.reservation.info.text1')) + " ", 1),
                                    _hoisted_7,
                                    _createTextVNode(_toDisplayString(_unref($lang)('app.reservation.info.text2')) + " ", 1),
                                    _hoisted_8,
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref($lang)('app.reservation.info.text3')), 1)
                                ])
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("section", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("ol", _hoisted_15, [
                                        _createElementVNode("li", null, [
                                            _createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("div", _hoisted_18, [
                                                        _hoisted_19,
                                                        _createElementVNode("h3", _hoisted_20, _toDisplayString(_unref($lang)('app.reservation.form.section.brand')), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_21, [
                                                        _createElementVNode("div", _hoisted_22, [
                                                            _createElementVNode("label", _hoisted_23, _toDisplayString(_unref($lang)('app.reservation.label.brand')), 1),
                                                            _createElementVNode("input", {
                                                                type: "text",
                                                                class: "form-control",
                                                                value: brandTitle.value,
                                                                readonly: ""
                                                            }, null, 8, _hoisted_24)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_25, [
                                                            _createElementVNode("label", _hoisted_26, _toDisplayString(_unref($lang)('app.reservation.label.store')), 1),
                                                            _createElementVNode("input", {
                                                                type: "text",
                                                                class: "form-control",
                                                                value: storeTitle.value,
                                                                readonly: ""
                                                            }, null, 8, _hoisted_27)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("div", _hoisted_28, [
                                                _createElementVNode("div", _hoisted_29, [
                                                    _createElementVNode("div", _hoisted_30, [
                                                        _hoisted_31,
                                                        _createElementVNode("h3", _hoisted_32, _toDisplayString(_unref($lang)('app.reservation.form.section.date')), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_33, [
                                                        _createElementVNode("div", _hoisted_34, [
                                                            _createElementVNode("label", _hoisted_35, _toDisplayString(_unref($lang)('app.reservation.label.date')), 1),
                                                            _createElementVNode("input", {
                                                                type: "text",
                                                                class: "form-control",
                                                                value: _unref(MainStore).date,
                                                                readonly: ""
                                                            }, null, 8, _hoisted_36)
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_37, [
                                                        _createElementVNode("div", _hoisted_38, [
                                                            _createElementVNode("label", _hoisted_39, _toDisplayString(_unref($lang)('app.reservation.label.time.slot')), 1),
                                                            _createElementVNode("input", {
                                                                type: "text",
                                                                class: "form-control text-center",
                                                                value: _unref(MainStore).time,
                                                                readonly: ""
                                                            }, null, 8, _hoisted_40)
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_41, [
                                                        _createElementVNode("div", _hoisted_42, [
                                                            _createElementVNode("label", _hoisted_43, _toDisplayString(_unref($lang)('app.reservation.label.headcount')), 1),
                                                            _createElementVNode("input", {
                                                                type: "text",
                                                                class: "form-control",
                                                                value: adults.value,
                                                                readonly: ""
                                                            }, null, 8, _hoisted_44)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_45, [
                                                            _hoisted_46,
                                                            _createElementVNode("input", {
                                                                type: "text",
                                                                class: "form-control",
                                                                value: children.value,
                                                                readonly: ""
                                                            }, null, 8, _hoisted_47)
                                                        ])
                                                    ]),
                                                    (formData.child && brand.value?.tw?.title === '明水然・樂')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                            _createTextVNode(_toDisplayString(_unref($lang)('app.reservation.form.notice.child.raku.line1')), 1),
                                                            _hoisted_49,
                                                            _createTextVNode(" " + _toDisplayString(_unref($lang)('app.reservation.form.notice.child.raku.line2')), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (formData.child && brand.value?.tw?.title === '明水然')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                            _createTextVNode(_toDisplayString(_unref($lang)('app.reservation.form.notice.child.minsuizen.line1')), 1),
                                                            _hoisted_51,
                                                            _createTextVNode(" " + _toDisplayString(_unref($lang)('app.reservation.form.notice.child.minsuizen.line2')), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (showInput.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                            _createVNode(MealsField, {
                                                                type: _unref(MealType).MAIN,
                                                                meals: meals.value.filter(v => v.type === _unref(MealType).MAIN),
                                                                min: formData.adult,
                                                                max: formData.adult,
                                                                depositType: store.value.depositType,
                                                                title: _unref($lang)('app.reservation.label.meal'),
                                                                onUpdate: setMealsValue
                                                            }, null, 8, ["type", "meals", "min", "max", "depositType", "title"])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    false
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                            _createVNode(MealsField, {
                                                                type: _unref(MealType).ADDITIONAL,
                                                                meals: meals.value.filter(v => v.type === _unref(MealType).ADDITIONAL),
                                                                min: formData.adult,
                                                                max: formData.adult,
                                                                depositType: store.value.depositType,
                                                                onUpdate: setAdditionalMealsValue,
                                                                title: _unref($lang)('app.reservation.label.additional')
                                                            }, null, 8, ["type", "meals", "min", "max", "depositType", "title"])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (showMenuImage.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                            _createElementVNode("div", {
                                                                class: "c-menu-thumbnail",
                                                                onClick: _cache[0] || (_cache[0] = ($event) => (showMenuLightbox.value = true))
                                                            }, [
                                                                _createElementVNode("img", {
                                                                    src: menuImageSrc.value,
                                                                    alt: "菜單",
                                                                    class: "c-menu-thumbnail__img"
                                                                }, null, 8, _hoisted_55),
                                                                _hoisted_56
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                                                        (showMenuLightbox.value)
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 0,
                                                                class: "c-lightbox",
                                                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (showMenuLightbox.value = false), ["self"])),
                                                                onTouchstart: onLightboxTouchStart,
                                                                onTouchmove: _withModifiers(onLightboxTouchMove, ["prevent"]),
                                                                onTouchend: onLightboxTouchEnd,
                                                                onMousedown: onLightboxMouseDown,
                                                                onMousemove: onLightboxMouseMove,
                                                                onMouseup: onLightboxMouseUp,
                                                                onMouseleave: onLightboxMouseUp
                                                            }, [
                                                                _createElementVNode("button", {
                                                                    class: "c-lightbox__close",
                                                                    onClick: _cache[1] || (_cache[1] = ($event) => (showMenuLightbox.value = false))
                                                                }, "✕"),
                                                                _createElementVNode("img", {
                                                                    src: menuImageSrc.value,
                                                                    alt: "菜單",
                                                                    class: "c-lightbox__img",
                                                                    style: _normalizeStyle({ transform: `translate(${lightboxTranslateX.value}px, ${lightboxTranslateY.value}px) scale(${lightboxScale.value})`, transformOrigin: 'center center' })
                                                                }, null, 12, _hoisted_57)
                                                            ], 32))
                                                            : _createCommentVNode("", true)
                                                    ])),
                                                    (formData.child)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                                            _createElementVNode("div", _hoisted_59, [
                                                                _createElementVNode("label", _hoisted_60, _toDisplayString(_unref($lang)('app.reservation.label.child.seat')), 1),
                                                                _createElementVNode("div", _hoisted_61, [
                                                                    _createElementVNode("div", _hoisted_62, [
                                                                        _createElementVNode("div", _hoisted_63, [
                                                                            _createElementVNode("div", null, [
                                                                                _withDirectives(_createElementVNode("input", {
                                                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((needChildSeat).value = $event)),
                                                                                    class: "form-check-input",
                                                                                    type: "radio",
                                                                                    name: "need-child-set",
                                                                                    id: "need-child-set-option-1",
                                                                                    value: true
                                                                                }, null, 512), [
                                                                                    [_vModelRadio, needChildSeat.value]
                                                                                ]),
                                                                                _createElementVNode("label", _hoisted_64, _toDisplayString(_unref($lang)('app.reservation.form.input.child.seat.yes')), 1)
                                                                            ]),
                                                                            (needChildSeat.value)
                                                                                ? (_openBlock(), _createBlock(SelectField, {
                                                                                    key: 0,
                                                                                    name: "child-set",
                                                                                    class: "c-select-item__select flex-grow-1",
                                                                                    "empty-options": true,
                                                                                    "default-value": '',
                                                                                    options: childSeatOptions.value,
                                                                                    onUpdate: setChildSeatData
                                                                                }, null, 8, ["options"]))
                                                                                : _createCommentVNode("", true)
                                                                        ])
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_65, [
                                                                        _createElementVNode("div", _hoisted_66, [
                                                                            _withDirectives(_createElementVNode("input", {
                                                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((needChildSeat).value = $event)),
                                                                                class: "form-check-input",
                                                                                type: "radio",
                                                                                name: "need-child-set",
                                                                                id: "need-child-set-option-2",
                                                                                value: false
                                                                            }, null, 512), [
                                                                                [_vModelRadio, needChildSeat.value]
                                                                            ]),
                                                                            _createElementVNode("label", _hoisted_67, _toDisplayString(_unref($lang)('app.reservation.form.input.child.seat.no')), 1)
                                                                        ])
                                                                    ])
                                                                ])
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("li", null, [
                                            (showInput.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                    _createElementVNode("div", _hoisted_69, [
                                                        _createElementVNode("div", _hoisted_70, [
                                                            _hoisted_71,
                                                            _createElementVNode("h3", _hoisted_72, _toDisplayString(_unref($lang)('app.reservation.form.section.info')), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_73, [
                                                            _createElementVNode("div", _hoisted_74, [
                                                                _createElementVNode("label", _hoisted_75, [
                                                                    _createTextVNode(_toDisplayString(_unref($lang)('app.reservation.form.input.name')), 1),
                                                                    _hoisted_76
                                                                ]),
                                                                _createVNode(InputField, {
                                                                    id: "input-name",
                                                                    name: "name",
                                                                    type: "text",
                                                                    rules: "required|nameStrict",
                                                                    class: "h-100 d-flex align-items-end",
                                                                    placeholder: _unref($lang)('app.reservation.form.placeholder.name'),
                                                                    "max-length": "30",
                                                                    onUpdate: setNameValue
                                                                }, null, 8, ["placeholder"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_77, [
                                                                _createElementVNode("label", _hoisted_78, _toDisplayString(_unref($lang)('app.reservation.form.input.gender')), 1),
                                                                _createVNode(SelectField, {
                                                                    name: "gender",
                                                                    options: genderOptions.value,
                                                                    "default-value": formData.gender,
                                                                    onUpdate: setGenderValue
                                                                }, null, 8, ["options", "default-value"])
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_79, [
                                                            _createElementVNode("label", _hoisted_80, [
                                                                _createTextVNode(_toDisplayString(_unref($lang)('app.reservation.form.input.phone')), 1),
                                                                _hoisted_81,
                                                                _createElementVNode("span", _hoisted_82, "(" + _toDisplayString(_unref($lang)('app.reservation.form.input.phone.help')) + ")", 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_83, [
                                                                _createVNode(PhoneField, {
                                                                    onUpdate: setPhoneValue,
                                                                    onUpdateCountryCode: setCountryCodeValue
                                                                })
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_84, [
                                                            _createElementVNode("div", _hoisted_85, [
                                                                _createElementVNode("label", _hoisted_86, [
                                                                    _createTextVNode(_toDisplayString(_unref($lang)('app.reservation.form.input.email')), 1),
                                                                    (emailRequired.value)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_87, "*"))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(_unref($lang)('app.reservation.form.input.email.optional')), 1))
                                                                ]),
                                                                _createVNode(InputField, {
                                                                    id: "input-email",
                                                                    name: "email",
                                                                    type: "email",
                                                                    rules: emailRules.value,
                                                                    placeholder: _unref($lang)('app.reservation.form.placeholder.email'),
                                                                    onUpdate: setEmailValue
                                                                }, null, 8, ["rules", "placeholder"])
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_89, [
                                                            _createElementVNode("div", _hoisted_90, [
                                                                _createElementVNode("label", _hoisted_91, [
                                                                    _createTextVNode(_toDisplayString(_unref($lang)('app.reservation.form.input.purpose')) + " ", 1),
                                                                    _createElementVNode("span", _hoisted_92, "(" + _toDisplayString(_unref($lang)('app.reservation.form.input.purpose.help')) + ")", 1)
                                                                ]),
                                                                _createElementVNode("div", _hoisted_93, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderPurposes.value, (orderPurpose) => {
                                                                        return (_openBlock(), _createElementBlock("div", null, [
                                                                            _withDirectives(_createElementVNode("input", {
                                                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((formData.purpose) = $event)),
                                                                                type: "checkbox",
                                                                                class: "btn-check",
                                                                                id: `btn-check-outlined-` + orderPurpose,
                                                                                value: orderPurpose,
                                                                                autocomplete: "off"
                                                                            }, null, 8, _hoisted_94), [
                                                                                [_vModelCheckbox, formData.purpose]
                                                                            ]),
                                                                            _createElementVNode("label", {
                                                                                class: "btn btn-sm btn-outline-medium-gray px-20px",
                                                                                for: `btn-check-outlined-` + orderPurpose
                                                                            }, _toDisplayString(_unref($lang)('app.reservation.form.input.purpose.' + orderPurpose)), 9, _hoisted_95)
                                                                        ]));
                                                                    }), 256))
                                                                ])
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_96, [
                                                            _createElementVNode("div", _hoisted_97, [
                                                                _createElementVNode("label", _hoisted_98, [
                                                                    _createTextVNode(_toDisplayString(_unref($lang)('app.reservation.form.input.note')) + " ", 1),
                                                                    _createElementVNode("span", _hoisted_99, "(" + _toDisplayString(_unref($lang)('app.reservation.form.note.help')) + ")", 1)
                                                                ]),
                                                                _createElementVNode("div", _hoisted_100, [
                                                                    _withDirectives(_createElementVNode("textarea", {
                                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((formData.customerNote) = $event)),
                                                                        class: "form-control",
                                                                        id: "exampleFormControlTextarea1",
                                                                        rows: "4",
                                                                        placeholder: _unref($lang)('app.reservation.form.placeholder.note')
                                                                    }, null, 8, _hoisted_101), [
                                                                        [_vModelText, formData.customerNote]
                                                                    ])
                                                                ])
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_102, [
                                                            _createElementVNode("div", _hoisted_103, [
                                                                _createElementVNode("div", _hoisted_104, [
                                                                    _createVNode(PolicyCheckField)
                                                                ])
                                                            ])
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_105, [
                                        _createElementVNode("div", _hoisted_106, [
                                            _createElementVNode("div", _hoisted_107, [
                                                _createElementVNode("h2", _hoisted_108, _toDisplayString(_unref($lang)('app.reservation.form.label.choose')), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_109, [
                                                _createElementVNode("div", _hoisted_110, _toDisplayString(storeTitle.value), 1),
                                                _createElementVNode("div", _hoisted_111, _toDisplayString(brandTitle.value), 1),
                                                _createElementVNode("ul", _hoisted_112, [
                                                    _createElementVNode("li", _hoisted_113, [
                                                        _createElementVNode("div", _hoisted_114, _toDisplayString(_unref($lang)('app.reservation.form.label.headcount')), 1),
                                                        _createElementVNode("div", _hoisted_115, [
                                                            _createTextVNode(_toDisplayString(formData.adult) + _toDisplayString(_unref($lang)('app.reservation.form.label.adult')) + " ", 1),
                                                            (formData.child)
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _createTextVNode(_toDisplayString(formData.child) + _toDisplayString(_unref($lang)('app.reservation.form.label.child')), 1)
                                                                ], 64))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _createElementVNode("ul", _hoisted_116, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedMeals.value, (selectedMeal) => {
                                                                return (_openBlock(), _createElementBlock("li", _hoisted_117, [
                                                                    _createElementVNode("div", null, _toDisplayString(selectedMeal.title), 1),
                                                                    _createElementVNode("div", _hoisted_118, [
                                                                        _createElementVNode("div", null, " x" + _toDisplayString(selectedMeal.quantity), 1),
                                                                        (store.value?.depositType === _unref(DepositType).MEAL)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_119, _toDisplayString(selectedMeal.price), 1))
                                                                            : _createCommentVNode("", true)
                                                                    ])
                                                                ]));
                                                            }), 256)),
                                                            (cleanFee.value && store.value?.depositType === _unref(DepositType).MEAL)
                                                                ? (_openBlock(), _createElementBlock("li", _hoisted_120, [
                                                                    _createElementVNode("div", null, " 10% " + _toDisplayString(_unref($lang)('app.reservation.form.label.clean.fee')), 1),
                                                                    _createElementVNode("div", _hoisted_121, _toDisplayString(_unref(priceFormat)(cleanFee.value)), 1)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ]),
                                                    _createElementVNode("li", _hoisted_122, [
                                                        _createElementVNode("div", _hoisted_123, _toDisplayString(_unref($lang)('app.reservation.form.label.date')), 1),
                                                        _createElementVNode("div", _hoisted_124, _toDisplayString(_unref(MainStore).date), 1)
                                                    ]),
                                                    (timeSlot.value)
                                                        ? (_openBlock(), _createElementBlock("li", _hoisted_125, [
                                                            _createElementVNode("div", _hoisted_126, _toDisplayString(_unref($lang)('app.reservation.form.label.time.slot')), 1),
                                                            _createElementVNode("div", _hoisted_127, [
                                                                _createElementVNode("span", null, _toDisplayString(_unref(dateFormatTaipei)(timeSlot.value.startTime, 'HH:mm')), 1),
                                                                _hoisted_128,
                                                                _createElementVNode("span", null, _toDisplayString(_unref(dateFormatTaipei)(timeSlot.value.endTime, 'HH:mm')), 1),
                                                                _createElementVNode("small", _hoisted_129, _toDisplayString(_unref($lang)('app.reservation.form.label.time.taiwan')), 1)
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (formData.phone)
                                                        ? (_openBlock(), _createElementBlock("li", _hoisted_130, [
                                                            _createElementVNode("div", _hoisted_131, _toDisplayString(_unref($lang)('app.reservation.form.label.payment.method')), 1),
                                                            _createElementVNode("div", _hoisted_132, _toDisplayString(isTaiwanPhone.value ? _unref($lang)('app.reservation.form.label.payment.method.atm') : _unref($lang)('app.reservation.form.label.payment.method.credit')), 1)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_133, [
                                                (grandTotal.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                                        _createElementVNode("div", _hoisted_135, _toDisplayString(_unref($lang)('app.reservation.form.label.deposit')), 1),
                                                        _createElementVNode("div", _hoisted_136, _toDisplayString(_unref(priceFormat)(grandTotal.value)) + " " + _toDisplayString(_unref($lang)('app.reservation.form.label.deposit.unit')), 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_137, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn c-btn-customization-primary",
                                                        onClick: back
                                                    }, [
                                                        _createElementVNode("span", null, _toDisplayString(_unref($lang)('app.reservation.form.btn.back')), 1)
                                                    ]),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn c-btn-customization-primary",
                                                        onClick: openModal
                                                    }, [
                                                        _createElementVNode("span", null, _toDisplayString(_unref($lang)('app.reservation.form.btn.submit')), 1)
                                                    ])
                                                ]),
                                                (grandTotal.value)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_138, " *" + _toDisplayString(_unref($lang)('app.reservation.form.submit.notice')), 1))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", {
                    ref_key: "guidelinesModal",
                    ref: guidelinesModal,
                    class: "modal fade",
                    id: "guidelinesModal",
                    tabindex: "-1",
                    "data-bs-backdrop": "static",
                    "data-bs-keyboard": "false",
                    "aria-labelledby": "guidelinesModalLabel",
                    "aria-hidden": "true"
                }, [
                    _createElementVNode("div", _hoisted_139, [
                        _createElementVNode("div", _hoisted_140, [
                            _createElementVNode("div", _hoisted_141, [
                                _createElementVNode("h2", {
                                    class: _normalizeClass(["modal-title fs-5 text-white", submitError.value ? `invisible` : '']),
                                    id: "guidelinesModalLabel"
                                }, _toDisplayString(_unref($lang)('app.reservation.info.label.instruction')), 3),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["btn-close", disabledInput.value || submitError.value ? `disabled d-none` : '']),
                                    "data-bs-dismiss": "modal",
                                    "aria-label": "Close"
                                }, null, 2)
                            ]),
                            _createElementVNode("div", _hoisted_142, [
                                (!submitError.value)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_143, [
                                        (store.value?.depositType !== _unref(DepositType).NONE)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_144, [
                                                _createElementVNode("div", _hoisted_145, [
                                                    (isTaiwanPhone.value)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createTextVNode(_toDisplayString(_unref($lang)('app.reservation.form.modal.payment.notice.atm')), 1)
                                                        ], 64))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createTextVNode(_toDisplayString(_unref($lang)('app.reservation.form.modal.payment.notice.credit')), 1)
                                                        ], 64))
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("li", _hoisted_146, [
                                            _createElementVNode("div", _hoisted_147, _toDisplayString(_unref($lang)('app.reservation.info.label.instruction')), 1),
                                            _createElementVNode("div", {
                                                class: "c-editor-content",
                                                innerHTML: modalReservationInstruction.value
                                            }, null, 8, _hoisted_148)
                                        ]),
                                        _createElementVNode("li", _hoisted_149, [
                                            _createElementVNode("div", _hoisted_150, _toDisplayString(_unref($lang)('app.reservation.info.label.prepaid')), 1),
                                            _createElementVNode("div", {
                                                class: "c-editor-content",
                                                innerHTML: modalPrepaidFee.value
                                            }, null, 8, _hoisted_151)
                                        ]),
                                        _createElementVNode("li", _hoisted_152, [
                                            _createElementVNode("div", _hoisted_153, _toDisplayString(_unref($lang)('app.reservation.info.label.refund')), 1),
                                            _createElementVNode("div", {
                                                class: "c-editor-content",
                                                innerHTML: modalRefundPolicy.value
                                            }, null, 8, _hoisted_154)
                                        ]),
                                        _createElementVNode("li", _hoisted_155, [
                                            _createElementVNode("div", _hoisted_156, _toDisplayString(_unref($lang)('app.reservation.info.label.notice')), 1),
                                            _createElementVNode("div", {
                                                class: "c-editor-content",
                                                innerHTML: modalNotice.value
                                            }, null, 8, _hoisted_157)
                                        ])
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_158, _toDisplayString(submitErrorMessage.value || _unref($lang)('app.reservation.form.error.text')), 1))
                            ]),
                            _createElementVNode("div", _hoisted_159, [
                                (!submitError.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_160, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((modalCheckbox).value = $event)),
                                                class: "form-check-input",
                                                type: "checkbox",
                                                id: "submit-check"
                                            }, null, 512), [
                                                [_vModelCheckbox, modalCheckbox.value]
                                            ]),
                                            _createElementVNode("label", _hoisted_161, _toDisplayString(_unref($lang)('app.reservation.form.modal.checkbox.text')), 1)
                                        ]),
                                        (_unref(rcKey))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_162))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn c-btn-customization-primary",
                                            disabled: !modalCheckbox.value || submitLocked.value || disabledInput.value,
                                            onClick: toVerify
                                        }, [
                                            (!disabledInput.value)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_164, _toDisplayString(_unref($lang)('app.reservation.form.modal.submit')), 1))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_165, _hoisted_167))
                                        ], 8, _hoisted_163)
                                    ], 64))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "btn c-btn-customization-primary",
                                        onClick: hideModalAndBack
                                    }, [
                                        _createElementVNode("span", null, _toDisplayString(_unref($lang)('app.reservation.form.btn.back')), 1)
                                    ]))
                            ])
                        ])
                    ])
                ], 512),
                _createElementVNode("div", {
                    ref_key: "duplicateModal",
                    ref: duplicateModal,
                    class: "modal fade",
                    id: "duplicateModal",
                    tabindex: "-1",
                    "data-bs-backdrop": "static",
                    "data-bs-keyboard": "false",
                    "aria-labelledby": "duplicateModalLabel",
                    "aria-hidden": "true"
                }, [
                    _createElementVNode("div", _hoisted_168, [
                        _createElementVNode("div", _hoisted_169, [
                            _createElementVNode("div", _hoisted_170, [
                                _createElementVNode("h2", _hoisted_171, _toDisplayString(_unref($lang)('app.reservation.form.duplicate.title')), 1),
                                _hoisted_172
                            ]),
                            _createElementVNode("div", _hoisted_173, [
                                _createElementVNode("div", _hoisted_174, [
                                    _createElementVNode("h3", _hoisted_175, _toDisplayString(_unref($lang)('app.reservation.form.duplicate.desc')), 1)
                                ]),
                                _createElementVNode("div", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storeList.value, (store) => {
                                        return (_openBlock(), _createElementBlock("div", _hoisted_176, [
                                            _createElementVNode("div", _hoisted_177, _toDisplayString(store.lang.title), 1),
                                            _createElementVNode("div", _hoisted_178, [
                                                _createElementVNode("div", null, _toDisplayString(_unref($lang)('app.reservation.form.phone.title')), 1),
                                                _createElementVNode("div", null, _toDisplayString(store?.phone), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_179, [
                                                _hoisted_180,
                                                _createElementVNode("div", null, _toDisplayString(store?.params.line_id), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_181, [
                                                _hoisted_182,
                                                _createElementVNode("div", null, _toDisplayString(store?.params.email), 1)
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_183, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn c-btn-customization-primary",
                                    onClick: hideDuplicateModalAndBack
                                }, [
                                    _createElementVNode("span", null, _toDisplayString(_unref($lang)('app.reservation.form.btn.back')), 1)
                                ])
                            ])
                        ])
                    ])
                ], 512),
                _createElementVNode("div", {
                    ref_key: "otpModal",
                    ref: otpModal,
                    class: "modal fade",
                    id: "otpModal",
                    tabindex: "-1",
                    "data-bs-backdrop": "static",
                    "data-bs-keyboard": "false",
                    "aria-labelledby": "otpModalLabel",
                    "aria-hidden": "true"
                }, [
                    _createElementVNode("div", _hoisted_184, [
                        _createElementVNode("div", _hoisted_185, [
                            _createElementVNode("div", _hoisted_186, [
                                _createElementVNode("h2", _hoisted_187, _toDisplayString(otpModalTitle.value), 1),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["btn-close", otpSending.value || otpVerifying.value ? 'disabled d-none' : '']),
                                    onClick: hideOtpModal
                                }, null, 2)
                            ]),
                            _createElementVNode("div", _hoisted_188, [
                                (!otpSendFailed.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_189, _toDisplayString(_unref($lang)('app.reservation.otp.modal.sent.to', otpTargetText.value)), 1))
                                    : _createCommentVNode("", true),
                                (otpFallbackToEmail.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_190, _toDisplayString(_unref($lang)('app.reservation.otp.notice.sms.fallback.email')), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_191, [
                                    _createElementVNode("label", _hoisted_192, _toDisplayString(_unref($lang)('app.reservation.otp.label.code')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((otpCode).value = $event)),
                                        type: "text",
                                        class: "form-control",
                                        maxlength: "6",
                                        inputmode: "numeric",
                                        autocomplete: "one-time-code",
                                        placeholder: _unref($lang)('app.reservation.otp.placeholder.code')
                                    }, null, 8, _hoisted_193), [
                                        [_vModelText, otpCode.value]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_194, [
                                    _createElementVNode("div", null, _toDisplayString(_unref($lang)('app.reservation.otp.remaining.expires', otpExpiresIn.value)), 1),
                                    _createElementVNode("div", null, _toDisplayString(_unref($lang)('app.reservation.otp.remaining.resend', otpResendIn.value)), 1)
                                ]),
                                (otpError.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_195, _toDisplayString(otpError.value), 1))
                                    : _createCommentVNode("", true),
                                (otpFailedCount.value > 0 && otpFailedCount.value < otpMaxFailedCount.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_196, _toDisplayString(_unref($lang)('app.reservation.otp.error.attempts')) + " " + _toDisplayString(otpFailedCount.value) + " / " + _toDisplayString(otpMaxFailedCount.value), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_197, [
                                    (verificationType.value === 'sms')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_198, _toDisplayString(_unref($lang)('app.reservation.otp.help.check.email')), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_199, _toDisplayString(_unref($lang)('app.reservation.otp.help.contact.store')), 1),
                                    (store.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
                                            (storeTitle.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_201, _toDisplayString(_unref($lang)('app.reservation.otp.help.store.title')) + "：" + _toDisplayString(storeTitle.value), 1))
                                                : _createCommentVNode("", true),
                                            (store.value?.phone)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_202, _toDisplayString(_unref($lang)('app.reservation.form.phone.title')) + "：" + _toDisplayString(store.value?.phone), 1))
                                                : _createCommentVNode("", true),
                                            (store.value?.params?.line_id)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_203, " Line ID：" + _toDisplayString(store.value?.params?.line_id), 1))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_204, _toDisplayString(_unref($lang)('app.reservation.otp.notice.seat.unreserved')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_205, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn c-btn-customization-primary",
                                    disabled: otpResendIn.value > 0 || otpSending.value,
                                    onClick: resendOtpWithRecaptcha
                                }, [
                                    (!otpSending.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_207, _toDisplayString(otpResendIn.value > 0
                                            ? _unref($lang)('app.reservation.otp.button.resend.countdown', otpResendIn.value)
                                            : _unref($lang)('app.reservation.otp.button.resend')), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_208, _toDisplayString(_unref($lang)('app.reservation.otp.button.sending')), 1))
                                ], 8, _hoisted_206),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn c-btn-customization-primary",
                                    disabled: otpVerifyDisabled.value,
                                    onClick: verifyOtpCode
                                }, [
                                    (!otpVerifying.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_210, _toDisplayString(_unref($lang)('app.reservation.otp.button.confirm')), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_211, _toDisplayString(_unref($lang)('app.reservation.otp.button.verifying')), 1))
                                ], 8, _hoisted_209)
                            ])
                        ])
                    ])
                ], 512),
                _createElementVNode("div", {
                    ref_key: "captchaModal",
                    ref: captchaModal,
                    class: "modal fade",
                    id: "captchaModal",
                    tabindex: "-1",
                    "data-bs-backdrop": "static",
                    "data-bs-keyboard": "false",
                    "aria-labelledby": "captchaModalLabel",
                    "aria-hidden": "true"
                }, [
                    _createElementVNode("div", _hoisted_212, [
                        _createElementVNode("div", _hoisted_213, [
                            _createElementVNode("div", _hoisted_214, [
                                _createElementVNode("h2", _hoisted_215, _toDisplayString(_unref(locale) === 'zh-TW' ? '圖形驗證' : 'Captcha Verification'), 1),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["btn-close", captchaLoading.value || captchaVerifying.value ? 'disabled d-none' : '']),
                                    onClick: hideCaptchaModal
                                }, null, 2)
                            ]),
                            _createElementVNode("div", _hoisted_216, [
                                _createElementVNode("div", _hoisted_217, _toDisplayString(_unref(locale) === 'zh-TW' ? '系統偵測到操作較頻繁，請先完成圖形驗證。' : 'We detected frequent activity. Please complete the captcha first.'), 1),
                                _createElementVNode("div", _hoisted_218, [
                                    (captchaImageData.value)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: captchaImageData.value,
                                            alt: "captcha",
                                            class: "border rounded bg-white",
                                            style: { "width": "160px", "height": "60px", "object-fit": "contain" }
                                        }, null, 8, _hoisted_219))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-outline-secondary btn-sm",
                                        disabled: captchaLoading.value || captchaVerifying.value,
                                        onClick: refreshCaptchaWithRecaptcha
                                    }, _toDisplayString(_unref(locale) === 'zh-TW' ? '重新整理圖形碼' : 'Refresh captcha'), 9, _hoisted_220)
                                ]),
                                _createElementVNode("div", _hoisted_221, [
                                    _createElementVNode("label", _hoisted_222, _toDisplayString(_unref(locale) === 'zh-TW' ? '請輸入圖形驗證碼' : 'Enter captcha code'), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((captchaCode).value = $event)),
                                        type: "text",
                                        class: "form-control text-uppercase",
                                        maxlength: "5",
                                        placeholder: _unref(locale) === 'zh-TW' ? '輸入 5 碼驗證碼' : 'Enter 5-character code'
                                    }, null, 8, _hoisted_223), [
                                        [_vModelText, captchaCode.value]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_224, [
                                    _createElementVNode("div", null, _toDisplayString(_unref(locale) === 'zh-TW'
                                        ? `驗證碼剩餘 ${captchaExpiresIn.value} 秒有效`
                                        : `Captcha expires in ${captchaExpiresIn.value}s`), 1)
                                ]),
                                (captchaError.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_225, _toDisplayString(captchaError.value), 1))
                                    : _createCommentVNode("", true),
                                (captchaFailedCount.value > 0 && captchaFailedCount.value < captchaMaxFailedCount.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_226, _toDisplayString(_unref(locale) === 'zh-TW'
                                        ? `錯誤次數 ${captchaFailedCount.value} / ${captchaMaxFailedCount.value}`
                                        : `Attempts ${captchaFailedCount.value} / ${captchaMaxFailedCount.value}`), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_227, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn c-btn-customization-primary",
                                    disabled: captchaVerifyDisabled.value,
                                    onClick: verifyCaptchaCode
                                }, [
                                    (!captchaVerifying.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_229, _toDisplayString(_unref(locale) === 'zh-TW' ? '確認驗證' : 'Verify'), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_230, _toDisplayString(_unref(locale) === 'zh-TW' ? '驗證中' : 'Verifying'), 1))
                                ], 8, _hoisted_228)
                            ])
                        ])
                    ])
                ], 512)
            ]));
        };
    }
});
